import { render } from "./group-client-terminal-list-section.vue?vue&type=template&id=679b5e95&scoped=true&ts=true"
import script from "./group-client-terminal-list-section.vue?vue&type=script&lang=ts"
export * from "./group-client-terminal-list-section.vue?vue&type=script&lang=ts"

import "./group-client-terminal-list-section.vue?vue&type=style&index=0&id=679b5e95&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679b5e95"]])

export default __exports__